import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import { BreakPointDesktop } from "../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space24,
    width: "100%",
    textAlign: "left",
  },
  /** Matches the size Dialog applies to its own title on desktop. */
  title: {
    textAlign: "center",
    [BreakPointDesktop]: {
      fontSize: "32px !important",
      lineHeight: "45px !important",
    },
  },
  rowButton: {
    background: theme.colors.Background,
  },
  toggleSelected: {
    outline: `2px solid ${theme.colors.Border4}`,
    outlineOffset: 3,
    borderRadius: 20,
  },
}));
